import { createWithEqualityFn } from 'zustand/traditional';

type PickupState = {
  lastClickedAt: number | null;
  isLoading: boolean;
};

type PickupInStore = {
  states: Record<string, PickupState>;
  setLastClickedAt: (orderId: string, time: number | null) => void;
  setLoading: (orderId: string, isLoading: boolean) => void;
  getStateByOrder: (orderId: string) => PickupState;
  getCooldownByOrder: (orderId: string) => number;
};

export const usePickupInStore = createWithEqualityFn<PickupInStore>((set, get) => ({
  states: {},
  setLastClickedAt: (orderId, time) => {
    const current = get().states[orderId] || { lastClickedAt: null, isLoading: false };
    set((state) => ({
      states: {
        ...state.states,
        [orderId]: { ...current, lastClickedAt: time },
      },
    }));
  },
  setLoading: (orderId, isLoading) => {
    const current = get().states[orderId] || { lastClickedAt: null, isLoading: false };
    set((state) => ({
      states: {
        ...state.states,
        [orderId]: { ...current, isLoading },
      },
    }));
  },
  getStateByOrder: (orderId) => {
    return get().states[orderId] || { lastClickedAt: null, isLoading: false };
  },
  getCooldownByOrder: (orderId) => {
    const state = get().states[orderId];
    if (!state?.lastClickedAt) return 0;

    const secondsPassed = Math.floor((Date.now() - state.lastClickedAt) / 1000);
    const remaining = 60 - secondsPassed;
    return remaining > 0 ? remaining : 0;
  },
}));
